<template>
  <div>
    <b-modal
      size="lg"
      id="bulkZuweisenModal"
      content-class="modal-form"
      :title="selectedAufgabenCount + ' Aufgaben neu zuweisen'"
      centered
      @hide="onHide"
    >
      <div>
        <div class="d-flex align-items-end" style="gap: 8px">
          <b-form-group class="mb-0" style="flex: 1 1 0; min-width: 0" label-for="bearbeiter">
            <template #label>
              <User :size="16" class="mr-1" style="color: #3699ff" />
              Bearbeiter/in
            </template>
            <AppSelect
              v-model="bearbeiter"
              :options="zugewiesenePersonOptions"
              :disabled="team != null"
              :state="bearbeiter !== null ? true : null"
              label="Bearbeiter/in"
              placeholder="Wähle eine/n Bearbeiter/in..."
              no-results-text="Bearbeiter/in nicht gefunden"
            />
          </b-form-group>

          <b-button
            @click="clickIch"
            size="sm"
            style="height: 38px; flex-shrink: 0"
            class="dialog-btn-secondary"
            :disabled="bearbeiter === currentUserId || team != null"
          >
            Ich
          </b-button>

          <b-form-group class="mb-0" style="flex: 1 1 0; min-width: 0" label-for="team">
            <template #label>
              <Users :size="16" class="mr-1" style="color: #3699ff" />
              Team
            </template>
            <AppSelect
              v-model="team"
              :options="teamOptions"
              :disabled="bearbeiter != null"
              :state="team !== null ? true : null"
              label="Team"
              placeholder="oder ein Team"
              hide-search
            />
          </b-form-group>
          <div style="width: 14px; height: 38px; display: flex; align-items: center; flex-shrink: 0">
            <i
              v-if="bearbeiter != null || team != null"
              class="fas fa-times text-danger"
              @click="resetPersonOderTeam"
              style="cursor: pointer"
            ></i>
          </div>
        </div>
      </div>
      <template #modal-footer="{ hide }">
        <b-button @click="hide" class="dialog-btn-secondary">Abbrechen</b-button>
        <b-button
          @click="$bvModal.show('bulkZuweisenConfirmModal')"
          class="dialog-btn"
          :disabled="bearbeiter == null && team == null"
          variant="primary"
        >
          Speichern
        </b-button>
      </template>
    </b-modal>

    <!-- Bestätigungsdialog  -->
    <b-modal
      id="bulkZuweisenConfirmModal"
      content-class="modal-form"
      centered
      hide-header
      footer-class="modal-footer--centered"
    >
      Willst du die ausgewählten Aufgaben wirklich neu zuweisen?
      <template #modal-footer="{ hide }">
        <b-button @click="hide" class="dialog-btn-secondary">Abbrechen</b-button>
        <b-button @click="neuZuweisen" class="dialog-btn" variant="primary">Speichern</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import apiService from '@/core/common/services/api.service';
import { mapState, mapGetters } from 'vuex';
import { changePeopleToCorrectShape, changeTeamsToCorrectShape } from '@/core/common/helpers/utils.js';
import { GET_AUFGABEN_NOTIFICATION_COUNT } from '@/core/aufgaben/stores/aufgaben.module';
import AppSelect from '@/components/common/app-select/app-select.vue';
import { User, Users } from 'lucide-vue';

export default {
  props: { selectedAufgabenCount: { type: Number }, selectedAufgabenIds: { type: Array, required: true } },
  components: { AppSelect, User, Users },
  data() {
    return {
      bearbeiter: null,
      team: null,
    };
  },
  computed: {
    ...mapState({
      users: state => state.users['users'],
    }),
    ...mapGetters(['currentUserId']),

    zugewiesenePersonOptions() {
      return changePeopleToCorrectShape(this.users);
    },
    teamOptions() {
      const abkuerzungen = {
        'Destination Operations Management': 'DOM',
        'Destination Success Management': 'DSM',
        'Customer Success Management': 'CSM',
        'Flight Operations Management': 'FOM',
      };
      return this.changeTeamsToCorrectShape(this.users).map(option => ({
        value: option.value,
        text: abkuerzungen[option.value] || option.text,
      }));
    },
  },
  methods: {
    neuZuweisen() {
      apiService
        .put('/aufgaben/bulk', {
          ids: this.selectedAufgabenIds,
          bearbeiter: this.bearbeiter,
          team: this.team,
        })
        .then(() => {
          this.toast('Erfolgreich zugewiesen.');
          this.$bvModal.hide('bulkZuweisenConfirmModal');
          this.$bvModal.hide('bulkZuweisenModal');
          this.$emit('neuZugewiesen');
          this.$store.dispatch(GET_AUFGABEN_NOTIFICATION_COUNT);
        });
    },
    onHide() {
      this.bearbeiter = null;
      this.team = null;
    },
    changeTeamsToCorrectShape,
    clickIch() {
      this.bearbeiter = this.currentUserId;
      this.team = null;
    },
    resetPersonOderTeam() {
      this.bearbeiter = null;
      this.team = null;
    },
  },
};
</script>
